export default __webpack_public_path__ + "images/referenzen/socialmedia/barclays_social_media_spot.mp4";